<template>
    <div>
        <div style="width: 100%;margin-bottom: 20px;">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>管理员管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
  
        <!-- 搜索筛选 -->
        <!-- 搜索筛选 -->
        <el-card class="box-card" style="margin-bottom: 20px;">
            <el-form :inline="true" class="user-search" :model="formInline" size="small">
                <el-form-item>
                    <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                    <el-button size="small" type="danger" icon="el-icon-plus" @click="handleedit1">新增</el-button>
                 
                </el-form-item>
            </el-form>
        </el-card>
  
        <!--列表-->
        <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
            element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column prop="uid" label="id" width="100" align="center">
          </el-table-column>
          <el-table-column prop="nickName" label="微信头像" width="100" align="center">
            <template slot-scope="scope">
                <div >
                    <el-image
                    style="width: 80px; height: 80px"
                    :src="scope.row.headImgUrl"
                    :preview-src-list="[scope.row.headImgUrl]" 
                    >
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                    </el-image>
                   
                </div>
            
           
            </template>
        </el-table-column>
          <el-table-column prop="username" label="名称" width="100" align="center">
          </el-table-column>
          <el-table-column prop="nickName" label="微信昵称" width="100" align="center">
        </el-table-column>
          <el-table-column prop="userRoles" label="角色" width="100" align="center">
            <template slot-scope="scope">
              {{formatName(scope.row.userRoles)}}
            </template>
          </el-table-column>
          <el-table-column prop="userRoles" label="管理的银行" min-width="200" align="center">
            <template slot-scope="scope">
                <div v-if="scope.row.manageWarehouseIds">
                    <div v-for="item in scope.row.manageWarehouseIds.split(',')" :key="item">   {{formatIDs(item)}}</div>
                </div>
               <div v-else>--</div>
           
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" min-width="300">
              <template slot-scope="scope">
                  <el-button size="mini" type="primary" icon="el-icon-edit"
                      @click="handleedit( scope.row)">编辑</el-button>
                  <!-- <el-button size="mini" type="info" @click="setStatus(scope.row)">显示</el-button> -->
                  <el-button size="mini" type="danger" icon="el-icon-delete"
                  @click="handledelete(scope.row)">删除</el-button>
             
              </template>
          </el-table-column>
        </el-table>
     
          <!-- 分页组件 -->
          <Pagination :child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 弹框 设代理和设置会员-->
       <el-dialog
      :close-on-click-modal="false"
        title="设置"
        :visible.sync="dialogVisible"
        width="30%"
        >
        <el-form >
            <!-- <el-form-item label="用户名称" >
               <el-input v-model='username' size="small" placeholder="请输入用户名"></el-input>    
            </el-form-item>
           
             <el-form-item label="用户角色">
                <el-select v-model="userRoles" placeholder="请选择用户角色">
                   
                    <el-option label="超级管理员" value='1'></el-option>
                 
                </el-select>
            </el-form-item>
             <el-form-item label="登录密码">
                <el-input v-model='password' placeholder="请输入用户密码"></el-input>    
             </el-form-item> -->
            <el-form-item label="用户名称" >
                <el-input v-model='editForm.username' size="small" placeholder="请输入用户名"></el-input>    
             </el-form-item>
             <el-form-item label="用户角色">
                <el-select v-model="editForm.userRoles" placeholder="请选择用户角色">
                   
                    <el-option :label="item.roleName" :value='item.roleId' v-for="(item,index) in role" :key="index">
                        <span style="float: left">{{ item.roleName }}</span>
                       
                    </el-option>
                 
                </el-select>
            </el-form-item>
            <el-form-item label="管理银行" style="width: 100%;">


                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                <div style="margin: 15px 0;"></div>
                <el-checkbox-group v-model="checkedLimit" @change="handleCheckedCitiesChange">
                  <el-checkbox v-for="(item,index) in cityList" :label="item" :value='item' :key="index">{{item}}</el-checkbox>
                </el-checkbox-group>
      
      
              </el-form-item>
             <el-form-item label="登录密码">
                <el-input v-model='editForm.password' placeholder="请输入用户密码"></el-input>    
             </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addEdit" >设置</el-button>
         
        </span>
      </el-dialog>
  
  
    </div>
  </template>
  
  <script>
    
  
    import {  userAdminList ,addEditUserAdmin , delUserAdmin , roleList , } from '../../api/pemission.js'
    import { getAllCity } from '@/api/basisMG.js'
  

   
    // 导出模块
    export default {
       
        // 模块数据
        data() {
            //数据  
            return {       
                checkAll: false,
                isIndeterminate: true,
                loading: true,
                visible: false,
                listData: [], 
                role:[],         
                dialogVisible: false,
                tagId:'',
                name:'',
                cityList:[],
                checkedLimit:[],
                // formInline: {
                //     start: 0,
                //     length: 5,
                   
                // },
                 // 分页参数
                //  pageparm: {
                //       currentPage: 1,
                //       pageSize: 5,
                //       total: 10,
                //       start: 0,
                //       length: 5
                //   },
                
                  editForm:{  
                    username:'',
                    userRoles:'',
                    password:'',
                  }
            }
        },
  
  
        watch: {},
  
        methods: {
            getAllCity(){
                getAllCity().then(res=>{
                    this.cityList = res.data
                })
            },
            handleCheckAllChange(val) {
                console.log('handleCheckAllChange', val)
                let list =[]
                if(val){
                    this.cityList.forEach(item=>{
                    list.push(item.id)
                    })
                    this.checkedLimit = list
                }
              
                this.editForm.manageWarehouseIds = val ? list.join(",") :"";
             
               
                this.isIndeterminate = false;
            },
            handleCheckedCitiesChange(value) {
                if(value && value.length){
                    let checkedCount = value.length
                    console.log("checkedCount",checkedCount)
                    console.log("value",value)

                    this.checkAll = checkedCount === this.cityList.length;
                    this.isIndeterminate = checkedCount > 0 && checkedCount < this.cityList.length;
                    this.editForm.manageWarehouseIds = value.join(",")
                }else{
                    this.editForm.manageWarehouseIds = ""
                }
              

            },
             // 查询
            //  search() {
            //     this.formInline.start = 0
			// 	this.pageparm.currentPage = 1
            //     this.getdata(this.formInline)
            // },
          
            showPop(){
                this.visible = true
                console.log(111)
            },
            // 获得用户数据
            getdata() {
              let param = this.formInline
              userAdminList(param).then(res=>{
                this.saveParams(this.$route.path,this.formInline)
                    if (res.code == '200') {
                        this.listData = res.data.content
                    
                        this.loading = false
                        this.pageparm.total = res.data.totalElements
                    }
                })
            },
             // 获得角色列表
          getdata1() {
          
            roleList({
                start: 0,
                    length:500,
            }).then(res=>{
                  if (res.code == '200') {
                      this.role = res.data.content
                   
                  }
              })
          },
          formatName(id){
              let name = ''
             
             this.role.forEach(item => {
                if( item.roleId == id) {
                    name = item.roleName
                }
                  
             })
              return name
          },
            handleedit(row){
                this.dialogVisible = true
                this.editForm = Object.assign({}, row)
                this.editForm.userRoles =  parseInt(this.editForm.userRoles)
                console.log("this.editForm.manageWarehouseIds",this.editForm.manageWarehouseIds)
                this.checkedLimit =  this.editForm.manageWarehouseIds? this.editForm.manageWarehouseIds.split(",").map(String):[]
                console.log("checkedLimit",this.checkedLimit)
            },
            formatIDs(id){
               
                let res = this.cityList.filter(item=>{
                    return item.id == id
                })
             
                return res[0]&&res[0].warehouseName?res[0].warehouseName:''
            },
            handleedit1(){
                this.dialogVisible = true
                this.editForm = {}
                
            },
            addEdit(){
                let param = this.editForm
                addEditUserAdmin(param).then(res=>{
                    if(res.code==200){
                    this.$message({
                        type: "success",
                        message: '操作成功'
                    })      
                    this.getdata()
                    this.dialogVisible = false
                    this.editForm = {}
                }else{
                    console.log(res.message)
                    // this.$message.error(res.message);
                }
              })
              
            },
            handledelete(row){
                let msg = '确定删除改菜单吗？'
              this.$confirm(msg, '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                  }).then(() => {
                    delUserAdmin(row).then(res=>{
                         
                          if(res.code==200){
                            this.$message({
                                type: "success",
                                message: '删除成功'
                                })
                            this.getdata()
                          }
                       })
                  })
            },
              // 分页插件事件
            //   callFather(parm) {
            //     this.pageparm.currentPage  = parm.currentPage
            //     this.pageparm.pageSize =  parm.pageSize 
            //     this.pageparm.start  = parm.currentPage - 1
            //     this.pageparm.length =  parm.pageSize 
            //     this.formInline.start = parm.currentPage - 1
            //     this.formInline.length = parm.pageSize
            //     this.getdata(this.formInline)
            // },
           
        },
        // 创建前状态(里面是操作)
        beforeCreate() { },
        // 创建完毕状态(里面是操作)
        created() {
            this.getParams(this.$route.path)
            this.getdata() 
            this.getdata1() 
            this.getAllCity()       
        },
        // 挂载前状态(里面是操作)
        beforeMount() { },
        // 挂载结束状态(里面是操作)
        mounted() { },
        // 更新前状态(里面是操作)
        beforeUpdate() { },
        // 更新完成状态(里面是操作)
        updated() { },
        // 销毁前状态(里面是操作)
        beforeDestroy() { },
        // 销毁完成状态(里面是操作)
        destroyed() { }
    };
  </script>
  
  <style scoped>
    .el-form-item {
        width: 40%;
        box-sizing: border-box;
    }
  
    .just-start {
        display: flex;
        justify-content: flex-start;
    }
  
    .marginT20 {
        margin-top: 20px;
    }
  </style>